import { useMutation } from '@tanstack/vue-query';
import { dscvrApi } from '@/shared/api';

export const useVerifyUserMutation = () => {
  return useMutation({
    mutationKey: ['verify-user-mutation'],
    mutationFn: dscvrApi.verify.verifyUser,
  });
};
